import { render } from "./DeleteRecord.vue?vue&type=template&id=01fd5426&scoped=true"
import script from "./DeleteRecord.vue?vue&type=script&lang=js"
export * from "./DeleteRecord.vue?vue&type=script&lang=js"

import "./DeleteRecord.vue?vue&type=style&index=0&id=01fd5426&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fd5426"]])

export default __exports__